<button (click)="openProgressPanel.emit()" class="button" fxFlex="grow" mat-button>
  <mat-icon>menu_open</mat-icon>
</button>